import React from 'react';

import { useDeviceTypes } from '@travel/traveler-core/hooks';
import { GalleryIcon } from '@travel/ui';
import type { GalleryMedia } from '@travel/ui/components/Gallery';
import { cx } from '@travel/utils';

import Media from 'components/Media';

import GalleryView from './GalleryView';
import MobileView from './MobileView';

import styles from './roomPlanGalleryCover.module.scss';

type Props = {
  medias: Array<GalleryMedia>;
  onOpenGallery: (index: number) => void;
  onOpenDetail: () => void;
  /** is first */
  isFirst: boolean;
};

function RoomPlanGalleryCover(props: Props) {
  const { medias, onOpenGallery, onOpenDetail, isFirst } = props;

  const { isSP, isTL } = useDeviceTypes();

  const handleOpenGallery = (index: number) => () => {
    onOpenGallery(index);
  };

  const handleClickGalleryIcon = () => {
    onOpenGallery(0);
  };

  if (isSP) {
    return <MobileView medias={medias} isFirst={isFirst} onOpenDetail={onOpenDetail} />;
  }

  if (medias.length >= 3) {
    return (
      <GalleryView
        medias={medias}
        handleClickGalleryIcon={handleClickGalleryIcon}
        handleOpenGallery={handleOpenGallery}
      />
    );
  }

  return (
    <div className={styles.singleMediaWrapper}>
      <Media
        className={cx(styles.singleMedia, styles.zoomMedia)}
        wrapperClassName={!isTL ? styles.mediaWrapper : undefined}
        key={`${medias[0].url}`}
        media={medias[0]}
        sizes="30vw"
        onClick={handleOpenGallery(0)}
      />
      {medias.length > 1 && (
        <GalleryIcon
          iconSize={16}
          photosCount={medias.length}
          className={styles.galleryIcon}
          onClick={handleClickGalleryIcon}
        />
      )}
    </div>
  );
}

export default RoomPlanGalleryCover;
